import { render } from "./FactureXClientView.vue?vue&type=template&id=138e60f4&scoped=true"
import script from "./FactureXClientView.vue?vue&type=script&lang=js"
export * from "./FactureXClientView.vue?vue&type=script&lang=js"

import "./FactureXClientView.vue?vue&type=style&index=0&id=138e60f4&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138e60f4"]])

export default __exports__